"use client";

import { Icon, type IconProps, Text } from "@pamperedchef/design-system";

import * as styles from "./Guarantee.module.scss";

export interface GuaranteeProps {
	icon: IconProps;
	label: string;
}

/**
 * Guarantee component
 */
export function Guarantee(props: GuaranteeProps): JSX.Element {
	return (
		<div className={styles["guarantee"]}>
			<Icon {...props.icon} size={20} className={styles["icon"]} />
			<Text styledAs="xsr" className={styles["label"]}>
				{props.label}
			</Text>
		</div>
	);
}
